












import { defineComponent } from "@vue/composition-api";
import { RunGallery } from "@/components.run/run-gallery";
import { getProps } from "../../ts/NodeComponent";

type GalleryParams = {};

export default defineComponent({
	
	emits:[
		"end", "previous"
	],
	components:{
		RunGallery,
	},
	props:getProps<GalleryParams>(),
	setup(_, context){

		const onEnd = () => context.emit("end");
		const onBack = () => context.emit("previous");

		return {
			onEnd,
			onBack
		};

	}
});
